var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"layout-draw"},[_c('el-container',[_c('layout-tools-left',{on:{"changeActiveClassId":_vm.createChat,"changeAgentId":_vm.createAgent}}),(!_vm.isAgent)?_c('layout-tools-main',{attrs:{"toolId":_vm.toolId}}):_c('layout-tools-agent',{attrs:{"agentId":_vm.agentId,"name":_vm.agentName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }